'use client';

import Image from 'next/image';
import { usePathname, useRouter } from 'next/navigation';
import React from 'react';
import { Routes } from 'types/enums';

interface AuthBackButtonProps {
  onClick?: () => void;
  icon?: React.ReactNode;
  className?: string;
  ariaLabel?: string;
  desktop?: boolean;
  mobile?: boolean;
}

const AuthBackButton: React.FC<AuthBackButtonProps> = ({
  onClick,
  icon,
  className,
  ariaLabel = 'Go back',
  desktop = false,
  mobile = false,
}) => {
  const router = useRouter();
  const pathname = usePathname();

  if (pathname === '/auth' || pathname.startsWith(Routes.AuthSocial)) {
    return <></>;
  }

  if (desktop && mobile) {
    console.error('AuthBackButton: Cannot use both desktop and mobile props simultaneously');
    return null;
  }

  const responsiveClasses = mobile ? 'sm:hidden' : desktop ? 'hidden sm:flex' : '';

  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      onClick();
    } else {
      router.back();
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`w-10 h-10 rounded-size-s flex items-center justify-center bg-Base-secondary-background hover:bg-Line-secondary hover:cursor-pointer transition-colors focus:outline-none ${responsiveClasses} ${className}`}
      aria-label={ariaLabel}>
      {icon || (
        <Image src={'/icons/common/chevron-left.svg'} alt={ariaLabel} width={24} height={24} />
      )}
    </button>
  );
};

export default AuthBackButton;
